<template>
	<div class="relative jere">
		<button
			type="button"
			:class="buttonClass"
			:id="buttonId"
			aria-expanded="false"
			aria-haspopup="true"
			v-on:click.stop="disabled ? null : (open = !open)"
		>
			<slot name="button"> </slot>
		</button>

		<transition name="zoomin">
			<div
				:class="dropdownClass"
				role="menu"
				aria-orientation="vertical"
				:aria-labelledby="buttonId"
				tabindex="-1"
				v-if="open"
				ref="dropdown"
				v-on:click.stop="closeDelayed()"
			>
				<slot name="items"> </slot>
			</div>
		</transition>

		<div class="fixed inset-0 overflow-hidden" v-if="open">
			<div
				class="absolute inset-0"
				aria-hidden="true"
				ref="overlay"
				v-on:click.stop="close()"
			></div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		buttonClass: {
			type: String,
			required: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		value: {
			type: String,
			required: false,
			default: "",
		},
		dropdownClass: {
			type: String,
			default:
				"origin-top-right absolute left-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10",
		},
		// alignment: {
		//     type: String,
		//     default: 'left'
		// }
	},
	data() {
		return {
			open: false,
		};
	},
	computed: {
		buttonId() {
			return "button-" + this._uid;
		},
	},
	watch: {
		open(val) {
			if (val) this.$emit('opened');
		},
	},
	methods: {
		close() {
			this.$refs.dropdown.addEventListener("transitionend", () => {
				this.$emit("close");
			});
			this.$nextTick(function () {
				this.open = false;
			});
		},
		/**
		 * fehlende Zeitverzögerung hat das Filter u.a. im Adminbereich verhindert
		 */
		closeDelayed() {
			setTimeout(() => {
				this.$emit("close");
				this.open = false;
			}, 75);
			console.log("close delayed");
		},
	},
};
</script>
